// JavaScript Document
/* Item List */
function wineli(callback,append,directory="",loop){
var list = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + directory + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
        jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;

        var display_num = "";
        if(loop) {
            var display_num = loop;
        } else {
            var display_num = len;
        }

        var caption = "";
    		for(var i=0; i < display_num; i++){

                if(json[i].cap){
                    caption = '<span class="caption">' + json[i].cap + '</span>'
                } else {
                    caption = ''
                }

        var price = "";
                if(json[i].price){
                    price = '<p class="price">' + json[i].price + '<span>円</span></p>'
                } else {
                    price = ''
                }

				if(json[i].itemnum != ""){
				if(json[i].category == "wine"){
					list = '<li><a href="https://saketora.com/products/' + json[i].itemnum + '" target="_top"><div class="imgArea"><img src="' + json[i].img + '" alt="' + json[i].name + '"></div><div class="txtArea"><p class="name">' + json[i].name1 + '</p>' + caption + price + '</div></a></li>';
				} else {
					list = '';
				}
				} else {
					list = '';
				}
   				$(append).append(list);
   			}
		}
    })
};